import { createAction } from 'redux-actions';

import fetch from 'features/common/fetch';

import * as types from './actionTypes';

const setBuildInfo = createAction(types.SET_BUILD_INFO, (buildInfo) => ({ buildInfo }));

export const fetchBeVersion = () => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.buildInfo, {
			onSuccess: [
				(response) => () => {
					if (!response.body) return;
					dispatch(setBuildInfo(response.body));
				},
			],
		}),
	);
};

export const resetAppState = createAction(types.RESET_REDUCERS);
